
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27.38 29.38"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M25.11 21.66h-.29v-9.81A11.13 11.13 0 0014.52.76a.91.91 0 00-1.8 0A11.13 11.13 0 002.55 11.85v9.81h-.28a2.27 2.27 0 100 4.53h22.84a2.27 2.27 0 100-4.53zM14.87 27.51h-2.36a.94.94 0 100 1.87h2.36a.94.94 0 100-1.87z"}})])])])
          )
        }
      }
    